<template>
  <MatchMedia v-slot="{ matches: isDesktop }" device="desktop">
    <div
      :aria-disabled="!product.available.value"
      :data-testid="`product-to-withdraw-row-${product.id}`"
      :class="[
        'product-to-withdraw__content',
        {
          'product-to-withdraw__content-grid': isDesktop,
          'product-to-withdraw__content-responsive': !isDesktop
        }
      ]"
    >
      <div class="product-to-withdraw__info-name">
        <component
          :is="isDesktop ? 'BaseText' : 'Heading'"
          size="md"
          :level="3"
          class="product-to-withdraw__title"
        >
          {{ product.name }}
        </component>
        <BaseText as="p" size="xs" class="product-to-withdraw__error-message">
          {{ errorMessage }}
        </BaseText>
      </div>
      <ProductToWithdrawCol
        :available="true"
        label-mobile="Valor Disponível"
        :value="totalGrossWorthAvailable"
      />
      <ProductToWithdrawCol
        :available="!!product.available.value"
        label-mobile="Mínimo para resgate"
        :value="minimumFinancialMovement"
      />
      <ProductToWithdrawCol
        :available="!!product.available.value"
        label-mobile="Mínimo de permanência"
        :value="minimumBalance"
      />
      <ProductToWithdrawCol
        :available="!!product.available.value"
        label-mobile="Resgate"
        :value="daysToRedeem"
      />
      <InputMoney
        v-if="product.available.value"
        class="product-to-withdraw__content-input"
        placeholder="R$ 0,00"
        :value="inputValue"
        @input="debouncedUpdateValue"
      />
    </div>
  </MatchMedia>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { debounce } from 'lodash-es';
import { Row, BaseText, InputMoney, Heading } from '@warrenbrasil/nebraska-web';
import { MatchMedia } from '@/modules/common/components/MatchMedia';
import { IWithdrawProduct } from '@/modules/wealth/services/withdraw';
import { ProductToWithdrawCol } from '../ProductToWithdrawCol';

@Component({
  components: {
    Row,
    Heading,
    BaseText,
    MatchMedia,
    InputMoney,
    ProductToWithdrawCol
  }
})
export default class ProductToWithdrawRow extends Vue {
  @Prop({ type: String, required: false })
  readonly errorMessage?: string;

  @Prop({ type: Object, required: true })
  readonly product!: IWithdrawProduct;

  public valueToInvest = 0;

  public debouncedUpdateValue = debounce(this.updateValue, 500);

  public get inputValue() {
    if (this.product.valueToInvest) return this.product.valueToInvest;
    return this.valueToInvest > 0 ? this.valueToInvest : undefined;
  }

  private get totalGrossWorthAvailable() {
    return this.product.totalGrossWorthAvailable.formatted || ' - ';
  }

  private get minimumFinancialMovement() {
    return this.product.minimumFinancialMovement.formatted || ' - ';
  }

  private get minimumBalance() {
    return this.product.minimumBalance.formatted || ' - ';
  }

  private get daysToRedeem() {
    return `${this.product.daysToRedeem} dias úteis` || ' - ';
  }

  @Emit()
  updateValue(value: number) {
    this.valueToInvest = value;
    return { ...this.product, valueToInvest: this.valueToInvest };
  }
}
</script>
<style lang="less" scoped>
.product-to-withdraw {
  &__content {
    > div {
      .from-md({display: flex;});

      &:not(.product-to-withdraw__info-name) {
        align-items: center;
      }
    }

    /deep/ .wrn-input {
      margin-top: 0px;
    }
  }
  &__title {
    .to-md({font-weight: bold;});
  }
  &__content-grid {
    display: grid;
    grid-template-columns: 3fr 1.1fr 1.3fr 1.5fr 1fr 1.5fr;
    gap: @size-spacing-x400;
    padding: @size-spacing-x400 0;
    min-height: 96px;
    align-items: baseline;
  }
  &__content-responsive {
    padding: @spacing-m 0;
    > div {
      padding-left: 0;
    }
  }
  &__info-name {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    align-self: center;
    .to-md({ padding-bottom: @size-spacing-x400 });
  }
  &__error-message {
    color: @text-on-error !important;
  }
  &__content-input {
    padding-right: @size-spacing-x400;
    .to-md({padding-right: 0; padding-top: @size-spacing-x500 });
  }
  &__content-min-invest {
    margin-top: @size-spacing-x150;
    display: flex;
    justify-content: space-between;
  }
}
</style>
